import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { CustomButton } from '../../../components/Button';

import styles from './BasketEmpty.module.sass';

const BasketEmpty: FC = () => {
  return (
    <div className={styles.empty}>
      <h2 className={styles.title}>Корзина пуста</h2>
      <p className={styles.text}>
        Загляните на главную, чтобы выбрать товары или найдите нужное в поиске
      </p>
      <Link to="/">
        <CustomButton variant="blue" className={styles.home}>
          Перейти на главную
        </CustomButton>
      </Link>
    </div>
  );
};

export default BasketEmpty;
